import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {filter, takeUntil, tap} from 'rxjs/operators';

import {environment} from '../../../../../environments/environment';
import {LittlesisLicensingService} from '../../services/littlesis-licensing.service';
import {License} from '../../services/licensing.interfaces';
import {Customer} from '../../../../core/modules/auth/services/customer.service';


@Component({
  selector: 'app-licensing-card',
  templateUrl: './licensing-card.component.html',
  styleUrls: ['./licensing-card.component.scss']
})
export class LicensingCardComponent implements OnInit, OnDestroy {

  customer: Customer;
  license: License;

  licensed = false;
  verifyingLicense = false;
  expiryMessage = '';
  iconColor = 'white';

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private _licensingSvc: LittlesisLicensingService
  ) { }

  ngOnInit(): void {
    this.verifyLicense();
  }

  verifyLicense(forceRefresh = false): void {
    this._licensingSvc.checkLicense(forceRefresh)
      .pipe(takeUntil(this.onDestroy$),
        tap(() => {this.verifyingLicense = true;}),
        filter(licensingState => !!licensingState))
      .subscribe((licenseState) => {
        this.verifyingLicense = false;
        this.license = licenseState.license;
        this.licensed = licenseState.licensed;

        if (licenseState.expiresIn <= 10) {
          this.iconColor = 'red';
        } else if (licenseState.expiresIn <= 30) {
          this.iconColor = 'amber';
        }

        if (licenseState.expiresIn > 1 && licenseState.expiresIn < 30) {
          this.expiryMessage = `Your Little SIS license will expire in ${licenseState.expiresIn} days`;
        } else if (licenseState.expiresIn === 2) {
          this.expiryMessage = `Your Little SIS license expires tomorrow`;
        } else if (licenseState.expiresIn === 1) {
          this.expiryMessage = `Your Little SIS license expires today`;
        }
      });
  }

  getQuote(): void {
    window.open(environment.urls.external.renew);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(null);
  }

}
